import EvaluatorOverview from "./EvaluatorOverview";

// Read-only list of every group's scorecards in the current module, for module reviewers (LIX-1797).
export default function AllEvaluations() {
  return (
    <EvaluatorOverview
      headerTranslation="global.menu.evaluation.all_evaluations"
      dbHeaderTranslation="global.menu.evaluation.all_evaluations"
      reviewerView={true}
      listType="module-reviewer"
    />
  );
}
